import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../instance';
import axios from 'axios';

const url = process.env.REACT_APP_API_BASE_URL; 

const initialState = {
    deleteloading: false,
   
};

  
export const deletePaybill = createAsyncThunk(
    "staffSettingSlice/deletePaybill",
    async (data) => {
      const res = await axiosInstance
        .delete(`${url}/api/v1/payments/deletePaybill/${data?.pbUid}`)
        .then((res) => res.data);
      return res;
    }
  );
 

export const deleteSlice = createSlice({
    name: 'delete',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
 
        
        .addCase(deletePaybill.pending, (state) => {
          state.deleteloading = true;
        })
        .addCase(deletePaybill.fulfilled, (state,action) => {
          state.deleteloading = false;
        })
        .addCase(deletePaybill.rejected, (state) => {
          state.deleteloading = false;
        })
 
  
    },
});

export default deleteSlice.reducer;
export const {} = deleteSlice.actions;
